"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redeem_referral_option = exports.get_earn_options_calculated = exports.get_earn_options = exports.get_referral_log_by_id = exports.get_logs = exports.base_url = void 0;
exports.base_url = "/api/referral/";
exports.get_logs = exports.base_url + "logs{?brand}";
exports.get_referral_log_by_id = exports.base_url + "log/{referral_log_id}";
exports.get_earn_options = exports.base_url + "earn-options{?brand,region}";
exports.get_earn_options_calculated = exports.base_url + "earn-options{?brand,region,user_id,referral_log_id}";
exports.redeem_referral_option = exports.base_url + "log/{referral_log_id}/redeem";
